module.exports = __webpack_public_path__ + "img/carl-taylor-signature.4c9a5305.svg";